import {
  getBusinessLines,
  getBusinessLineListEntry,
  addBusinessLine as addBusinessLineToFirestore,
  setBusinessLine as setBusinessLineInFirestore
} from "@/modules/firestore_repo";

const defaultData = {
  isHidden: false,
  isOem: false,
  parents: [],
  customizations: [],
  legacyName: ""
};

export const state = {
  businessLinesList: null
};

export const getters = {
  getBusinessLinesList: state => {
    return state.businessLinesList || [];
  }
};

export const actions = {
  fetchBusinessLinesList: async ({ commit }) => {
    commit("setLoading", true);

    const data = await getBusinessLines();

    commit("setBusinessLinesList", data);
    commit("setLoading", false);
  },

  addBusinessLine: async ({ commit }, payload) => {
    commit("setLoading", true);

    const { businessLine } = payload.data;
    const businessLineData = {
      ...defaultData,
      ...businessLine,
      legacyName: businessLine.legacyName || ""
    };

    await addBusinessLineToFirestore(businessLineData);

    const data = await getBusinessLines();

    commit("setBusinessLinesList", data);

    commit("setLoading", false);
  },

  editBusinessLine: async ({ commit }, payload) => {
    commit("setLoading", true);

    const { businessLine } = payload.data;
    const businessLineData = {
      ...defaultData,
      ...businessLine,
      legacyName: businessLine.legacyName || ""
    };

    await setBusinessLineInFirestore(businessLine.id, businessLineData);

    const data = await getBusinessLines();

    commit("setBusinessLinesList", data);

    commit("setLoading", false);
  },

  deleteBusinessLine: async ({ commit }, payload) => {
    commit("setLoading", true);

    const { businessLine } = payload.data;
    const businessLineData = {
      ...defaultData,
      ...businessLine,
      legacyName: businessLine.legacyName || "",
      isHidden: true
    };

    await setBusinessLineInFirestore(businessLine.id, businessLineData);

    const data = await getBusinessLines();

    commit("setBusinessLinesList", data);

    commit("setLoading", false);
  }
};

export const mutations = {
  setBusinessLinesList: (state, payload) => {
    state.businessLinesList = payload
      .filter(item => !item.isHidden)
      .map(item => {
        return getBusinessLineListEntry(item);
      });
  }
};
